import { createContext } from 'preact-compat'
import { TranslationCategory } from '../libs/translationsUtils/translations'
import communityOverview from '../pages/community-overview'
import groupOverview from '../pages/group-overview'
import { WidgetElement } from '../server-middleware/widgetRepository'
import { Context } from '../server-middleware/context'
import { Module } from '../services/modules'

export interface PageContext {
  widgets?: WidgetElement[]
  name: string
  url: string
  breadcrumbs: BreadCrumb[]
}

interface BreadCrumb {
  phrase: [TranslationCategory, string]
  url: string
}

export interface PageContextWithURL extends PageContext {
  fullUrl: URL
}

export type PageContextProvider = (context: Context) => PageContext

const pages: PageContextProvider[] = [
  communityOverview,
  groupOverview
]

export const getPageContext = (context: Context): PageContextWithURL => {
  const currentUrl = context.url
  for (const pageContextProvider of pages) {
    const pageContext = pageContextProvider(context)
    if (pageContext.url === currentUrl.pathname) {
      return { ...pageContext, fullUrl: currentUrl }
    }
  }

  return { ...page404(context), fullUrl: currentUrl }
}

const page404: PageContextProvider = (context: Context) => {
  return {
    widgets: [],
    name: '404',
    url: '/404',
    breadcrumbs: [
      homepageBreadcrumbs(context.modules)
    ]
  }
}

export const page404WithoutContext: PageContext = {
  widgets: [],
  name: '404',
  url: '/404',
  breadcrumbs: [
    {
      phrase: ['Common', 'breadcrumb.homepage.text'],
      url: '/'
    }
  ]
}

export const homepageBreadcrumbs = (modules: Module[]): BreadCrumb => {
  const breadcrumbPhrase = modules.includes('CommunityOverviewOpenForAllUsers')
    ? 'breadcrumb.homepage.community_overview_active_text'
    : 'breadcrumb.homepage.text'

  return {
    phrase: ['Common', breadcrumbPhrase],
    url: '/'
  }
}

export const CurrentPageContext = createContext<PageContextWithURL>({
  ...page404WithoutContext,
  fullUrl: new URL('http://127.0.0.1/404')
})
